<template>
  <v-ons-page  id="QuizPage">
    
    <div class="iframe-center">
      <iframe id="iframe" loading="lazy" frameborder="0" :src="urlQuiz"></iframe>
    </div>  
    <v-ons-button v-show="showButton" class="botao" style="margin-top:-300px !important" @click="resgatarHnk()">Resgate Aqui Sua Heineken® 00</v-ons-button>
  </v-ons-page>
</template>
<style scoped>
iframe {
  height: 100vh;
  width: 100%;
  overflow:hidden;
}

.iframe-center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  overflow:hidden;
}
</style>


<script>
import TirarSelfieVue from './TirarSelfie.vue';
import DirecionamentoVue from './Direcionamento.vue';
export default {
  name: 'Quiz',
  key: 'Quiz',
  props: ['pageStack'],
  data() {
    return {
      urlQuiz:this.$hnk00_uri+"/frameQuiz",
      showButton:false
    };
  },
  mounted() { 
    var self = this
    window.addEventListener('message', function (e) {
      //window.console.log(e)
      if (e.data == "endQuiz") {
       // window.alert("end quiz received")
        var action = JSON.parse(localStorage.getItem("action"));
        if ((action.flGeladeira) || (action.flVending)) { 
          self.showButton = true
        }
        
      }
    });
  },
  methods: {
    resgatarHnk() { 
      var action = JSON.parse(localStorage.getItem("action"));
      if (action.flGeladeira) { 
        this.$emit("push",DirecionamentoVue)
      }
      if (action.flVending) { 
        this.$emit("push",TirarSelfieVue)
      }
    }
  }
}
</script>